import React from 'react';
import DropdownItem from '@/components/DropdownItem';

const DictionaryReportTools = ({
  code,
  downloadStart,
  isDownloading,
  report,
  reportType,
}) => (
  <DropdownItem
    icon="download"
    textId="actions.download"
    onClick={() => downloadStart('downloads', code, reportType, report, true)}
    disabled={isDownloading}
  />
);
export default DictionaryReportTools;
